
  
  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
  
$('#left-poder-sph').click(function() {
  var_l_sph = $('#4634217414727_option_4').val();
  console.log(var_l_sph); 
  unify_values_l();
  fetch_sku_l();
});


$('#right-poder-sph').click(function() {
  var_r_sph = $('#4634217414727_option_5').val();
  console.log(var_r_sph); 
  unify_values_r();
  fetch_sku_r();
});


function unify_values_l(){
  sku_values_l = var_l_sph ;
  console.log(sku_values_l);
}

function unify_values_r(){
  sku_values_r = var_r_sph;
  console.log(sku_values_r);
}

var l_express = 0;
var r_express = 0;

function check_express(){
  //este switch1 está en discount-lc.liquid, y es el que verifica si esta uno o dos ojos activados
  // 1 = disponible , 2 = no disponible, 3 = disponible sin envío express
  if ($('#switch1').is(':checked')) { 
    if (l_express ==2 || r_express ==2) {
        $('.lc-nostock-container').css('display','inline-block');
        $('.lc-express-container').hide();
        $('.lc-step-3, .lc-step-2').hide();
    }else if (l_express != 0 && r_express != 0) {
      if (l_express ==1 && r_express ==1){
        $('.lc-express-container').css('display','inline-block');
        $('.lc-nostock-container').hide(); 
        $('.lc-step-3, .lc-step-2').show();
      }else if (l_express == 3 && r_express == 3){
        $('.lc-express-container').hide();
        $('.lc-nostock-container').hide(); 
        $('.lc-step-3, .lc-step-2').show();
      } else {
        $('.lc-nostock-container').css('display','inline-block'); 
        $('.lc-express-container').hide();
        $('.lc-step-3, .lc-step-2').hide();
      }
    }else{
      $('.lc-express-container, .lc-nostock-container, .lc-step-3, .lc-step-2').hide();
    }
  }else{
    if (l_express ==1){
      $('.lc-express-container').css('display','inline-block'); 
      $('.lc-step-3, .lc-step-2').show();
      $('.lc-nostock-container').hide();
    }else if (l_express == 3){
      $('.lc-express-container').hide();
      $('.lc-nostock-container').hide(); 
      $('.lc-step-3, .lc-step-2').show();
    } else {
      $('.lc-nostock-container').css('display','inline-block'); 
      
      $('.lc-step-3, .lc-step-2').hide();
      $('.lc-express-container').hide();
    }
  }
}
  
$('#switch1').change(function(){check_express();});

function fetch_sku_l(){
  switch (sku_values_l) {

case '-0.25' :  l_express = 2; check_express(); break;
case '-0.50' :  l_express = 2; check_express(); break;
case '-0.75' :  l_express = 2; check_express(); break;
case '-1.00' :  l_express = 1; check_express(); break;
case '-1.25' :  l_express = 1; check_express(); break;
case '-1.50' :  l_express = 1; check_express(); break;
case '-1.75' :  l_express = 1; check_express(); break;
case '-2.00' :  l_express = 1; check_express(); break;
case '-2.25' :  l_express = 1; check_express(); break;
case '-2.50' :  l_express = 1; check_express(); break;
case '-2.75' :  l_express = 1; check_express(); break;
case '-3.00' :  l_express = 1; check_express(); break;
case '-3.25' :  l_express = 1; check_express(); break;
case '-3.50' :  l_express = 1; check_express(); break;
case '-3.75' :  l_express = 1; check_express(); break;
case '-4.00' :  l_express = 1; check_express(); break;
case '-4.25' :  l_express = 1; check_express(); break;
case '-4.50' :  l_express = 1; check_express(); break;
case '-4.75' :  l_express = 1; check_express(); break;
case '-5.00' :  l_express = 1; check_express(); break;
case '-5.25' :  l_express = 1; check_express(); break; 
case '-5.50' :  l_express = 1; check_express(); break;
case '-5.75' :  l_express = 2; check_express(); break;  
case '-6.00' :  l_express = 1; check_express(); break;
case '-6.50' :  l_express = 2; check_express(); break; 
case '-7.00' :  l_express = 2; check_express(); break; 
case '-7.50' :  l_express = 2; check_express(); break; 
case '-8.00' :  l_express = 2; check_express(); break; 
case '-8.50' :  l_express = 2; check_express(); break; 
case '-9.00' :  l_express = 2; check_express(); break; 
case '-9.50' :  l_express = 2; check_express(); break; 
case '-10.00' :  l_express = 2; check_express(); break; 
case '-10.50' :  l_express = 2; check_express(); break; 
case '-11.00' :  l_express = 2; check_express(); break; 
case '-11.50' :  l_express = 2; check_express(); break; 
case '-12.00' :  l_express = 2; check_express(); break;
case '+0.50' :  l_express = 2; check_express(); break; 
case '+0.75' :  l_express = 2; check_express(); break; 
case '+1.00' :  l_express = 2; check_express(); break; 
case '+1.25' :  l_express = 2; check_express(); break; 
case '+1.50' :  l_express = 2; check_express(); break; 
case '+1.75' :  l_express = 2; check_express(); break; 
case '+2.00' :  l_express = 2; check_express(); break; 
case '+2.25' :  l_express = 2; check_express(); break; 
case '+2.50' :  l_express = 1; check_express(); break; 
case '+2.75' :  l_express = 2; check_express(); break; 
case '+3.00' :  l_express = 2; check_express(); break; 
case '+3.25' :  l_express = 2; check_express(); break; 
case '+3.50' :  l_express = 2; check_express(); break; 
case '+3.75' :  l_express = 2; check_express(); break; 
case '+4.00' :  l_express = 2; check_express(); break; 
case '+4.25' :  l_express = 2; check_express(); break; 
case '+4.50' :  l_express = 2; check_express(); break; 
case '+4.75' :  l_express = 2; check_express(); break; 
case '+5.00' :  l_express = 2; check_express(); break; 
case '+5.25' :  l_express = 2; check_express(); break; 
case '+5.50' :  l_express = 2; check_express(); break; 
case '+5.75' :  l_express = 2; check_express(); break; 
case '+6.00' :  l_express = 2; check_express(); break; 
case '+6.50' :  l_express = 2; check_express(); break; 
case '+7.00' :  l_express = 2; check_express(); break; 
case '+7.50' :  l_express = 2; check_express(); break; 
case '+8.00' :  l_express = 2; check_express(); break; 

}

}//fetch_sku()



function fetch_sku_r(){
  switch (sku_values_r) {

case '-0.25' :  r_express = 2; check_express(); break;
case '-0.50' :  r_express = 2; check_express(); break;
case '-0.75' :  r_express = 2; check_express(); break;
case '-1.00' :  r_express = 1; check_express(); break;
case '-1.25' :  r_express = 1; check_express(); break;
case '-1.50' :  r_express = 1; check_express(); break;
case '-1.75' :  r_express = 1; check_express(); break;
case '-2.00' :  r_express = 1; check_express(); break;
case '-2.25' :  r_express = 1; check_express(); break;
case '-2.50' :  r_express = 1; check_express(); break;
case '-2.75' :  r_express = 1; check_express(); break;
case '-3.00' :  r_express = 1; check_express(); break;
case '-3.25' :  r_express = 1; check_express(); break;
case '-3.50' :  r_express = 1; check_express(); break;
case '-3.75' :  r_express = 1; check_express(); break;
case '-4.00' :  r_express = 1; check_express(); break;
case '-4.25' :  r_express = 1; check_express(); break;
case '-4.50' :  r_express = 1; check_express(); break;
case '-4.75' :  r_express = 1; check_express(); break;
case '-5.00' :  r_express = 1; check_express(); break;
case '-5.25' :  r_express = 1; check_express(); break; 
case '-5.50' :  r_express = 1; check_express(); break;
case '-5.75' :  r_express = 2; check_express(); break;  
case '-6.00' :  r_express = 1; check_express(); break;
case '-6.50' :  r_express = 2; check_express(); break; 
case '-7.00' :  r_express = 2; check_express(); break; 
case '-7.50' :  r_express = 2; check_express(); break; 
case '-8.00' :  r_express = 2; check_express(); break; 
case '-8.50' :  r_express = 2; check_express(); break; 
case '-9.00' :  r_express = 2; check_express(); break; 
case '-9.50' :  r_express = 2; check_express(); break; 
case '-10.00' :  r_express = 2; check_express(); break; 
case '-10.50' :  r_express = 2; check_express(); break; 
case '-11.00' :  r_express = 2; check_express(); break; 
case '-11.50' :  r_express = 2; check_express(); break; 
case '-12.00' :  r_express = 2; check_express(); break;
case '+0.50' :  r_express = 2; check_express(); break; 
case '+0.75' :  r_express = 2; check_express(); break; 
case '+1.00' :  r_express = 2; check_express(); break; 
case '+1.25' :  r_express = 2; check_express(); break; 
case '+1.50' :  r_express = 2; check_express(); break; 
case '+1.75' :  r_express = 2; check_express(); break; 
case '+2.00' :  r_express = 2; check_express(); break; 
case '+2.25' :  r_express = 2; check_express(); break; 
case '+2.50' :  r_express = 1; check_express(); break; 
case '+2.75' :  r_express = 2; check_express(); break; 
case '+3.00' :  r_express = 2; check_express(); break; 
case '+3.25' :  r_express = 2; check_express(); break; 
case '+3.50' :  r_express = 2; check_express(); break; 
case '+3.75' :  r_express = 2; check_express(); break; 
case '+4.00' :  r_express = 2; check_express(); break; 
case '+4.25' :  r_express = 2; check_express(); break; 
case '+4.50' :  r_express = 2; check_express(); break; 
case '+4.75' :  r_express = 2; check_express(); break; 
case '+5.00' :  r_express = 2; check_express(); break; 
case '+5.25' :  r_express = 2; check_express(); break; 
case '+5.50' :  r_express = 2; check_express(); break; 
case '+5.75' :  r_express = 2; check_express(); break; 
case '+6.00' :  r_express = 2; check_express(); break; 
case '+6.50' :  r_express = 2; check_express(); break; 
case '+7.00' :  r_express = 2; check_express(); break; 
case '+7.50' :  r_express = 2; check_express(); break; 
case '+8.00' :  r_express = 2; check_express(); break; 

}


}//fetch_sku()